import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Input, DatePicker, Space, Select } from 'antd';
import { SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { Btns, FormContainer } from "./styled";
import dayjs from 'dayjs';
import InputMask from 'react-input-mask';


export function ModalTratamentoFiscal({
    isOpen,
    onClose,
    id,
    fetchPendentesData,
    fetchEmitidasData,
    idCliente,
    categoria,
    ano,
    mes,
    situacaoId
}) {

    const dateFormat = 'YYYY-MM-DD';
    const [atualDate, setAtualDate] = useState(dayjs().format(dateFormat));
    const [isId, setIsId] = useState("");
    const [newData, setNewData] = useState({
        cliente: "",
        nome: "",
        dataReferencia: "",
        Apontamento: "",
        valor: "",
        situacaoId: "",
        situacaoNome: "",
        dataCadastro: "",
        usuarioCadastro: "",
        dataAlteracao: "",
        usuarioAlteracao: "",
        files: []
    })

    useEffect(() => {
        setAtualDate(dayjs().format(dateFormat));
        consultarData(id, idCliente, categoria, ano, mes, situacaoId);
        listarData(id, idCliente, categoria, ano, mes, situacaoId);
        setIsId(id);
    }, []);

    const consultarData = async (id, idCliente, categoria, ano, mes, situacaoId) => {
        const url = "/portal/rest/contador/fiscal/apontamento/consultar";
        const param = {
            ano: ano,
            categoria: {
                id: categoria
            },
            cliente: {
                id: idCliente
            },
            mes: mes,
            situacao: {
                id: situacaoId
            }
        };

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            setNewData(prevState => ({
                ...prevState,
                cliente: response.data.cliente.id,
                nome: response.data.cliente.nome,
                Apontamento: response.data.categoria.nome,
                valor: response.data.valor,
                situacaoId: response.data.situacao.id,


            }));

        } catch {
            toast.error("Erro ao buscar os dados.");
        }
    }

    const listarData = async (id, idCliente, categoria, ano, mes, situacaoId) => {
        const url = "/portal/rest/contador/fiscal/apontamento/arquivos/listar";
        const param = {
            ano: ano,
            categoria: {
                id: categoria
            },
            cliente: {
                id: idCliente
            },
            mes: mes,
            situacao: {
                id: situacaoId
            }
        };

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            setNewData(prevState => ({
                ...prevState,
                dataReferencia: response.data.dataReferencia,
                dataCadastro: response.data.dataCadastro,
                usuarioCadastro: response.data.usuarioCadastro,
                dataAlteracao: response.data.dataAlteracao,
                usuarioAlteracao: response.data.usuarioAlteracao,
                files: response.data.files
            }));
        } catch {
            toast.error("Erro ao buscar os dados.");
        }
    }

    const postData = async () => {
        const url = "/portal/rest/contador/fiscal/apontamento/situacao/atualizar";
        const param = {
            ano: ano,
            categoria: {
                id: categoria
            },
            cliente: {
                id: idCliente
            },
            mes: mes,
            situacao: {
                id: newData.situacaoId
            }
        };

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            toast.success("Dados atualizados com sucesso.");
            onClose();
            fetchPendentesData();
            fetchEmitidasData();
        } catch {
            toast.error("não foi possível salvar os dados.");
        }
    }

    const convertTimestampToDate = (timestamp) => {
        return new Date(parseInt(timestamp, 10));
    };

    const handleCancel = () => {
        onClose();
    };


    const onChangeSituacao = (value, nome) => {
        setNewData({
            ...newData,
            situacaoId: value,
            situacaoNome: nome
        });
    }

    return (
        <>
            <Modal
                title="Tratamento de Apontamento Fiscal"
                open={isOpen}
                onOk={postData}
                onCancel={handleCancel}
                width={1100}
            >
                <FormContainer>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="cliente"
                        >
                            <label className="label" tmlFor="">Cliente:</label>
                            <Input disabled placeholder={newData.cliente || "Id cliente"} value={newData.cliente} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="nome"
                        >
                            <label className="label" htmlFor="">Nome:</label>
                            <Input disabled placeholder={newData.nome || "Nome"} value={newData.tipo} />
                        </Form.Item>
                    </div>

                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="dataReferenci"
                        >
                            <label className="label" htmlFor="">Data referência:</label>
                            <Input disabled placeholder={newData.dataReferencia || "data referência"} value={newData.dataReferencia} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="apontamento"
                        >
                            <label className="label" htmlFor="">Apontamento:</label>
                            <Input disabled placeholder={newData.Apontamento || "data referência"} value={newData.Apontamento} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            label="Valor"
                            name="valor"
                            disabled
                        >
                            <InputMask
                                maskChar="0"
                                placeholder="Valor"
                                defaultValue={newData.valor}
                                // onChange={handleValorChange}
                                className="ant-input"
                                addonBefore="R$"
                                disabled
                            >
                                {(inputProps) => <Input disabled {...inputProps} />}
                            </InputMask>
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="situação"
                            value={newData.situacaoId}
                            defaultValue={newData.situacaoId}
                            style={{ width: "200px" }}
                        >
                            <label className="label" htmlFor="">Situação:</label>
                            <Select
                                showSearch
                                placeholder={newData.situacaoId}
                                value={newData.situacaoId}
                                onChange={onChangeSituacao}
                            >
                                <Select.Option value="">Selecionar</Select.Option>
                                <Select.Option value="P">Pendente</Select.Option>
                                <Select.Option value="F">Fechada</Select.Option>

                            </Select>
                        </Form.Item>
                    </div>

                    <div className="form-content">

                        <Form.Item
                            className="form-item"
                            name="dataCadastro"
                        >
                            <label className="label" htmlFor="">Data cadastro:</label>
                            <Input disabled placeholder={newData.dataCadastro || "data cadastro"} value={newData.dataCadastro} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="usuarioCadastro"
                        >
                            <label className="label" htmlFor="">Usuário cadastro:</label>
                            <Input style={{ width: "auto" }} disabled placeholder={newData.usuarioCadastro || "Usuário cadastro"} value={newData.usuarioCadastro} />
                        </Form.Item>

                        <Form.Item
                            className="form-item"
                            name="dataAlteracao"
                        >
                            <label className="label" htmlFor="">Data alteração:</label>
                            <Input disabled placeholder={newData.dataAlteracao || "Data alteracao"} value={newData.dataAlteracao} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"

                            name="usuarioAlteracao"
                        >
                            <label className="label" htmlFor="">Usuário alteração:</label>
                            <Input style={{ width: "auto" }} disabled placeholder={newData.usuarioAlteracao || "Data alteração"} value={newData.usuarioAlteracao} />
                        </Form.Item>
                    </div>
                    <Form.Item
                        className="form-item"
                        name="files"
                    >
                        <div>{newData.files}</div>
                    </Form.Item>
                </FormContainer>
            </Modal>
        </>
    );
};

export default ModalTratamentoFiscal;